import React from "react";
import { TableHead, TableRow } from "@material-ui/core";
import TableHeadCell from "./TableHeadCell";
import { TableColumn } from "../../../Models/Entities";

export default () => {
  const cells = [
    { value: "Omnium Values", columnType: TableColumn.OmniumValues },
    { value: "Customer Values", columnType: TableColumn.CustomerValues },
    { value: "De Value", columnType: TableColumn.DeValue },
    { value: "En Value", columnType: TableColumn.EnValue },
    { value: "Fr Value", columnType: TableColumn.FrValue },
    { value: "It Value", columnType: TableColumn.ItValue },
    { value: "Order", columnType: TableColumn.Order },
    { value: "Master", columnType: TableColumn.Master },
    { value: "De Abb.", columnType: TableColumn.DeAbb },
    { value: "En Abb.", columnType: TableColumn.EnAbb },
    { value: "Fr Abb.", columnType: TableColumn.FrAbb },
    { value: "It Abb.", columnType: TableColumn.ItAbb },
  ];
  return (
    <TableHead>
      <TableRow>
        {cells.map((cell) => {
          return (
            <TableHeadCell
              name={cell.value}
              columnType={cell.columnType}
              active={false}
            />
          );
        })}
      </TableRow>
    </TableHead>
  );
};
